import { ReadonlyURLSearchParams, useRouter } from 'next/navigation';

export function toggleUseCartFilter(
  useCartFilters: boolean,
  router: ReturnType<typeof useRouter>,
  pathname: string,
  searchParams: URLSearchParams
) {
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.set('filterByCart', useCartFilters ? 'false' : 'true');
  router.replace(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
  return newSearchParams;
}

export function clearAllFilters(
  router: ReturnType<typeof useRouter>,
  pathname: string,
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  shouldFilterByCart: boolean
) {
  const newSearchParams = new URLSearchParams();

  newSearchParams.set('filterByCart', shouldFilterByCart ? 'true' : 'false');
  searchParams.get('productType') &&
    newSearchParams.set('productType', searchParams.get('productType') as string);
  router.push(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
}
// Set one filter value without clearing other filters.
// E.g. when ring=halo, set ring=solitaire and keep both ring types in that array.

export function setFilterUrlFilterChoice(
  router: ReturnType<typeof useRouter>,
  pathname: string,
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  key: string,
  value: string,
  checked: boolean,
  clearSibling: boolean = false,
  clearKeys: string[] = []
) {
  const newSearchParams = new URLSearchParams(searchParams);
  if (checked) {
    if (!newSearchParams.has(key)) {
      if (clearSibling) {
        newSearchParams.delete(key);
      }
    }
    newSearchParams.append(key, value);
  } else {
    if (newSearchParams.has(key)) {
      const existingFilter = newSearchParams.getAll(key);
      if (existingFilter.includes(value)) {
        const updatedFilter = existingFilter.filter((v) => v !== value);
        newSearchParams.delete(key);
        updatedFilter.forEach((v) => newSearchParams.append(key, v));
      }
    }
  }
  clearKeys?.forEach((k) => newSearchParams.delete(k));
  router.replace(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
  return newSearchParams;
}

export function getReferer(url: string | null): string | undefined {
  if (!url) {
    return undefined;
  }
  const urlObj = new URL(url);
  return `https://${urlObj.hostname}/`;
}

export function clearUrlFilter(
  router: ReturnType<typeof useRouter>,
  pathname: string,
  searchParams: URLSearchParams | ReadonlyURLSearchParams,
  key: string,
  clearKeys: string[] = []
) {
  const newSearchParams = new URLSearchParams(searchParams);
  newSearchParams.delete(key);
  clearKeys.forEach((k) => newSearchParams.delete(k));
  router.replace(`${pathname}?${newSearchParams.toString()}`, { scroll: false });
}

export function routeToPathKeepParams(
  router: ReturnType<typeof useRouter>,
  pathname: string,
  searchParams: URLSearchParams | ReadonlyURLSearchParams
) {
  router.push(`${pathname}?${searchParams.toString()}`, { scroll: false });
}
